export const FORWARD = 1;
export const REVERSE = -1;
